<template>
  <section :class="{ 'is-active' : isActive }">
    <plan-and-rate-header
      v-model="isActive"
      :description="description"
      @clickDescription="showDescriptionDialog = true"
    >
      {{ container.name }}
      <template
        v-if="isPlanBased"
        #subtitle
      >
        Rates
      </template>
    </plan-and-rate-header>
    <template v-if="isActive">
      <rates-attribute
        v-for="(rateAttribute) in container.rateAttributes"
        :key="`${container.id.join('_')}-${rateAttribute.id}`"
        :rate-attribute="rateAttribute"
      />
    </template>
    <el-dialog
      v-if="showDescriptionDialog"
      :visible.sync="showDescriptionDialog"
      :title="`Class Description${container.containerNames.length > 1 ? 's' : ''}`"
      top="70px"
      width="425px"
    >
      <div>
        <template v-for="(desc, idx) in container.description">
          <h4
            :key="container.containerNames[idx]"
            v-text="`Class ${container.containerNames[idx]}`"
          />
          <p
            :key="`description-${idx}`"
            v-text="desc"
          />
        </template>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  // vuex
  import { mapState } from 'vuex';
  // components
  import PlanAndRateHeader from '@/components/PlanAndRateHeader';
  import RatesAttribute from './Attribute';

  /**
   * A styled component used for each attribute prop to display the name, rate basis, and the rate values table.
   *
   * @vuedoc
   * @exports Rates/Container
   * @category Components
   */
  export default {
    name: 'RatesContainer',
    components: { PlanAndRateHeader, RatesAttribute },
    props: {
      container: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      isActive: true,
      showDescriptionDialog: false,
    }),
    computed: {
      ...mapState('rateAttributes', ['isPlanBased']),
      /**
       * Returns a joined string of the container descriptions array.
       *
       * @returns {string}
       */
      description() {
        return this.isPlanBased
          ? ''
          : this.container.description.join(', ');
      },
    },
  };
</script>

<style lang="scss" scoped>
section {
  margin-bottom: 20px;
}
</style>
